import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Pagination } from "swiper/modules";
import { imgBaseUrl } from "../Const";
import { Link } from "react-router-dom";
import NoPropertyImg from "../images/no_property.png";
import { formatShortNumber, getQuarter, onError } from "./CommonFun";
import { RELocation } from "./icons/IconSvg";

export default function ProjectSlider({ projectData, isFlag }) {
    const formatNames = (data) => {
        const names = data.map((cat) => cat.name);
        if (names.length === 1) return names[0];
        if (names.length === 2) return `${names[0]} & ${names[1]}`;
        return `${names.slice(0, -1).join(", ")} & ${names[names.length - 1]}`;
    };
    return (
        <div className="our-latest-sec ">
            <div className="slider-section project-slider">
                <Swiper
                    modules={[Navigation, Pagination]}
                    slidesPerView={1}
                    spaceBetween={10}
                    navigation={{ nextEl: ".custom-next", prevEl: ".custom-prev" }}
                    pagination={{ clickable: true, el: ".property-pagination" }}
                    loop={false}
                    breakpoints={{ 0: { slidesPerView: 1 }, 575: { slidesPerView: 2 }, 768: { slidesPerView: 2 }, 1024: { slidesPerView: 3 }, 1400: { slidesPerView: 4 } }}
                >
                    {projectData.length > 0 &&
                        projectData.map((item, i) => (
                            <SwiperSlide key={`project_${i}`}>
                                {/* <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12" key={i}> */}
                                <div className="slider-card-prp slider-body slider-body-none position-relative">
                                    <Link to={`/project-details/${item?.slug}_${item?.uId}`} title={item.title} className="link_anchor"></Link>
                                        <div className="slider-card project-slider-card">
                                            <div className="slide-card-img image-swiper-wrapper">
                                                {item?.images.length > 0 ? (
                                                    <Swiper
                                                        modules={[Navigation, Pagination]}
                                                        slidesPerView={1}
                                                        spaceBetween={20}
                                                        navigation={{ nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" }}
                                                        pagination={{ clickable: true, dynamicBullets: true }}
                                                        loop={false}
                                                        className="slider_inner"
                                                    >
                                                        {item?.images.length > 0 &&
                                                            item?.images
                                                                .filter((img) => !img.needHide)
                                                                .sort((a, b) => {
                                                                    if (a.isCover) return -1;
                                                                    if (b.isCover) return 1;
                                                                    return a.orderRank - b.orderRank;
                                                                })
                                                                .map((slide, index) => (
                                                                    <SwiperSlide className="crad_wrapper_img" key={index}>
                                                                        {/* <LazyLoad once={true}> */}
                                                                        <img
                                                                            src={imgBaseUrl + slide?.path}
                                                                            alt={item?.title}
                                                                            onError={onError}
                                                                            loading="lazy"
                                                                        />
                                                                        {/* </LazyLoad> */}
                                                                    </SwiperSlide>
                                                                ))}
                                                        <div className="swiper-button-prev"></div>
                                                        <div className="swiper-button-next"></div>
                                                    </Swiper>
                                                ) : (
                                                    <img src={NoPropertyImg} alt="no property" />
                                                )}
                                            </div>
                                            <div className="heading_title">
                                                <h3 className="card_ellipsis">{item?.title}</h3>
                                                {item?.developer?.name && (
                                                    <p>
                                                        By <b>{item?.developer?.name}</b>
                                                    </p>
                                                )}
                                            </div>
                                            {item?.address?.locality && (
                                                <div className="geo-location">
                                                    <RELocation />
                                                    <span className="card_ellipsis">{item?.address?.locality ?? ""}</span>
                                                </div>
                                            )}
                                            {item?.category?.length > 0 && (
                                                <div className="key_info_value">
                                                    <p className="card_ellipsis">{formatNames(item.category)}</p>
                                                </div>
                                            )}
                                            <div>
                                                <div className="flex items-center info_wrapper">
                                                    {item?.monetary?.currency && (item?.monetary?.minimumPrice || item?.monetary?.maximumPrice) && (
                                                        <div className="item-summary card_payment_plans line_height">
                                                            <bdi className="flex items-center card_ellipsis">
                                                                {`${item?.monetary?.currency} ${
                                                                    item?.monetary?.minimumPrice ? formatShortNumber(item?.monetary?.minimumPrice) : formatShortNumber(item?.monetary?.maximumPrice)
                                                                }`}
                                                            </bdi>
                                                            <span className="card_ellipsis">Launch Price</span>
                                                        </div>
                                                    )}
                                                    {item?.completion?.completionDate && (
                                                        <div className="item-summary card_payment_plans line_height">
                                                            <bdi className="flex items-center card_ellipsis">{getQuarter(item?.completion?.completionDate)}</bdi>
                                                            <span className="card_ellipsis">Handover</span>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    
                                </div>
                                {/* </div> */}
                            </SwiperSlide>
                        ))}
                </Swiper>
                <div className="custom-nav-arrows">
                    <button className={`custom-prev ${projectData.length === 2 ? "swiper-button-lock" : ""}`} aria-label="Previous Slide">
                        ❮
                    </button>
                    <button className="custom-next" aria-label="Next Slide">
                        ❯
                    </button>
                </div>
            </div>
        </div>
    );
}
